import axios from 'axios';
import { API_BASE_URL, getAuthHeaders } from './api';

const VOUCHERS_URL = `${API_BASE_URL}/vouchers`;
const CHART_OF_ACCOUNTS_URL = `${API_BASE_URL}/accounting/chart-of-accounts`;

export async function getChartOfAccounts() {
  const response = await axios.get(CHART_OF_ACCOUNTS_URL, { headers: getAuthHeaders() });
  return Array.isArray(response.data) ? response.data : [];
}

export async function getVouchers(type) {
  const params = type && type !== 'all' ? { type } : {};
  const response = await axios.get(VOUCHERS_URL, { headers: getAuthHeaders(), params });
  return response.data?.data || [];
}

export async function getVoucherDetail(voucherNumber) {
  const response = await axios.get(`${VOUCHERS_URL}/${encodeURIComponent(voucherNumber)}`, {
    headers: getAuthHeaders()
  });
  return response.data?.data;
}

export async function createVoucher(payload) {
  const response = await axios.post(VOUCHERS_URL, payload, { headers: getAuthHeaders() });
  return response.data;
}
